<template>
  <v-content>
    <section>
      <v-parallax src="assets/banner.jpg" height="500">
        <v-layout align-start align-content-end>
          <v-btn 
            @click="$router.push('/pronos')"
            light 
            outline>My pronostics</v-btn>
        </v-layout>
        <v-layout
          column
          align-center
          justify-center
          class="secondary--text"> 
          <h1 
            class="secondary--text mb-2 display-1 text-xl-center">
            The website to bet on the baby's arrival
          </h1>
          <div class="subheading mb-3 text-xs-center">
            Place your bet on the baby's arrival date, gender, weight and size.
          </div>
            <v-btn
              class="red lighten-2 mt-5"
              dark
              round
              large
              @click="$router.push('create')"
              >
              Start
            </v-btn>
        </v-layout>
      </v-parallax>
    </section>
    <section>
      <v-layout
        column
        wrap
        class="my-5"
        align-center
      >
        <v-flex xs12>
          <v-container grid-list-xl>
            <v-layout row wrap align-center>
              <v-flex xs12 md4>
                <v-card class="elevation-0 transparent">
                  <v-card-text class="text-xs-center">
                    <v-icon x-large class="blue--text text--lighten-2">pregnant_woman</v-icon>
                  </v-card-text>
                  <v-card-title primary-title class="layout justify-center">
                    <div class="headline text-xs-center">Create your pool</div>
                  </v-card-title>
                  <v-card-text>
                    No more post-its on the fridge to make your birth forecasts! You will be able to do it here simply and share it with your friends.
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 md4>
                <v-card class="elevation-0 transparent">
                  <v-card-text class="text-xs-center">
                    <v-icon x-large class="blue--text text--lighten-2">share</v-icon>
                  </v-card-text>
                  <v-card-title primary-title class="layout justify-center">
                    <div class="headline">Guess and Share</div>
                  </v-card-title>
                  <v-card-text>
                    Simple and fast, make your predictions in a few clicks on the birth of your baby or that of your friends ..
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 md4>
                <v-card class="elevation-0 transparent">
                  <v-card-text class="text-xs-center">
                    <v-icon x-large class="blue--text text--lighten-2">cake</v-icon>
                  </v-card-text>
                  <v-card-title primary-title class="layout justify-center">
                    <div class="headline text-xs-center">Winners</div>
                  </v-card-title>
                  <v-card-text>
                    Who will be designated the closest to reality by predicting the best date, sex but also the size and weight of the baby?
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </section>
  </v-content>
</template>

<script>
import Wizard from '@/components/Wizard'
import Account from '@/components/auth/Account'

export default {
  data () {
    return {
      title: 'Baby prono',
      account: null,
    }
  },
  components: {
    Wizard, Account
  },
}
</script> 